'use strict';

angular.module('imagetrend.components')
    .controller('FileUploadModalController', ['$scope', '$uibModalInstance', 'Upload', 'Documents', 'file_content', 'FileTypes', 'file_upload_existing_docs', 'parameters', '$rootScope', 'question_id', function ($scope, $uibModalInstance, Upload, Documents, file_content, FileTypes, file_upload_existing_docs, parameters, $rootScope, question_id) {

        $scope.vm = {
            file: null,
            file_content: file_content,
            file_name: null
        }
        $scope.uploading = false;
        $scope.working = false;
        $scope.file_upload_existing_docs = file_upload_existing_docs;
        $scope.existingFileSelected = false;
        $scope.newFileSelected = false;
        $scope.document_id = null;
        $scope.uploaded_document_id = null;
        $scope.uploaded_document_code = null;
        $scope.uploadMessage = null;
        $scope.errorMessage = null;
        $scope.user_id = $rootScope.userID;
        $scope.validationText = false;

        if (parameters && parameters.user_id) {
            $scope.user_id = parameters.user_id
        }
        FileTypes.getByEnterprise().then(function(data) {
            if (data != null && data.length > 0) {
                $scope.extensions = data.toString();
            } else {
                $scope.extensions = "'*'";
            }
            
        });

        $scope.fileChange = function () {
            if (!$scope.working) {
                $scope.uploading = false;
            }
        }

        $scope.fileUpdated = function (file) {
            $scope.newFileSelected = file != null;
            $scope.uploaded_document_id = null;
            $scope.uploaded_document_code = null;
            $scope.errorMessage = null;
            if (file == null) {
                $scope.working = false;
                $scope.uploading = false;
                return;
            }
            $scope.working = true;

            function base64Fallback() {
                Upload.base64DataUrl(file).then(function (content) {
                    $scope.vm.file_content = content;
                    $scope.working = false;
                    $scope.uploading = false;
                });
            }

            Documents.storageAvailable().then(function (storageResponse) {
                if (storageResponse.documentStorageAvailable) {
                    if (file.type && file.type.indexOf('image') === 0) {
                        Upload.base64DataUrl(file).then(function (content) {
                            $scope.vm.file_content = content;
                        });
                    }
                    $scope.uploading = true;
                    $scope.uploadMessage = 'Uploading file...';
                    Documents.storageUpload(null, {
                        file: file,
                        name: file.name,
                        description: '',
                        document_type_id: null
                    }, function (progress) {
                        $scope.uploadMessage = 'Upload progress: ' + progress.percent + '%';
                    }).then(function (response) {
                        $scope.uploaded_document_id = response.data.id;
                        $scope.uploaded_document_code = response.data.code;
                        $scope.vm.file_name = response.data.file_name;
                        $scope.uploadMessage = 'Upload complete';
                        $scope.working = false;
                        $scope.uploading = false;
                    }).catch(function (error) {
                        $scope.uploaded_document_id = null;
                        $scope.working = false;
                        $scope.uploading = false;
                        $scope.errorMessage = 'Upload failed: ' + ((error && error.data && error.data.Message) || 'Please try again.');
                    });
                } else {
                    base64Fallback();
                }
            }).catch(function () {
                base64Fallback();
            });
        }

        $scope.existingFileUpdated = function (document_id) {
            $scope.existingFileSelected = document_id != null;
            $scope.document_id = document_id;
        }

        $scope.filePicked = function () {
            $scope.uploading = true;
        }

        $scope.documentParameters = {
            user_id: $scope.user_id,
            question_id: question_id
        }

        $scope.save = function () {
            if ($scope.newFileSelected && $scope.uploaded_document_id != null) {
                $uibModalInstance.close({
                    document_id: $scope.uploaded_document_id,
                    document_code: $scope.uploaded_document_code,
                    file_name: $scope.vm.file_name,
                    is_new_upload: true
                });
            }
            else if ($scope.newFileSelected && $scope.vm.file != null && $scope.vm.file_content != null) {
                $uibModalInstance.close({
                    file_name: $scope.vm.file.name,
                    file_content: $scope.vm.file_content
                });
            }
            else if ($scope.document_id != null && $scope.existingFileSelected) {
                $uibModalInstance.close({
                    document_id: $scope.document_id
                });
            }
            else if ($scope.file_upload_existing_docs == true)
            {
                $scope.validationText = true;
            }
            else {
                $uibModalInstance.dismiss('cancel');
            }
        }

        $scope.close = function () {
            $uibModalInstance.dismiss('cancel');
        }
    }])
;